export const PUBLIC_ROUTE = {
  FORGET_PASSWORD: '/forgotpassword',
  RESULT: '/esito-operazione',
  PAGE_404: '/404',
  PAGE_500: '/500',
  ERROR_NETWORK: '/errorNetwork',
  RESET_PASSWORD: '/resetpassword',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
};

export const PRIVATE_ROUTE = {
  AFFIX: '/affix',
  ALERT: '/alert',
  AUTOCOMPLETE: '/autocomplete',
  BACK_TO_TOP: '/backToTop',
  BLANK_PAGE: '/blank_page',
  BREADCRUMB: '/breadcrumb',
  BUTTON: '/button',
  CALENDAR: '/calendar',
  CHECKBOX: '/checkbox',
  CLOSURE: '/closure',
  NEW_CLOSURE: '/newClosure',
  WORKHOURS: '/workhours',
  NEW_WORKHOURS: '/newWorkhours',
  CODE_MIRROR: '/codeMirror',
  CUSTOMER: '/customer',
  NEW_CUSTOMER: '/newCustomer',
  DASHBOARD: '/',
  DROPDOWN: '/dropdown',
  DROPZONE: '/dropzone',
  DUTY: '/duty',
  MY_PROFILE: '/profile',
  NEW_DUTY: '/newDuty',
  EDITOR: '/editor',
  FORM: '/allFormComponent',
  FORM_WITH_VALIDATION: '/FormsWithValidation',
  FORM_WITH_STEPPERS: '/stepperForms',
  FRAPPE_CHART: '/frappeChart',
  GOOGLE_CHART: '/googleChart',
  INPUT: '/InputField',
  MENU: '/menu',
  MESSAGE: '/message',
  MODAL: '/modal',
  NOTIFICATION: '/notification',
  COMMUNICATION: '/communication',
  NEW_COMMUNICATION: '/newPushNotification',
  OP_BADGE: '/op_badge',
  OP_CARD: '/op_card',
  OP_CAROUSEL: '/op_carousel',
  OP_COLLAPSE: '/op_collapse',
  OP_POPOVER: '/op_popover',
  OP_TAG: '/op_tag',
  OP_TIMELINE: '/op_timeline',
  OP_TOOLTIP: '/op_tooltip',
  OPERATOR: '/operator',
  OPERATOR_UNAVAILABILITY: '/operatorUnavailability',
  NEW_OPERATOR: '/newOperator',
  NEW_OPERATOR_UNAVAILABILITY: '/newOperatorUnavailability',
  PAGINATION: '/pagination',
  POPCONFIRM: '/Popconfirm',
  PROGRESS: '/progress',
  RADIOBOX: '/radiobox',
  RATING: '/rating',
  REACT_CHART_2: '/ReactChart2',
  REACT_DATES: '/reactDates',
  RECHARTS: '/reecharts',
  SELECT: '/selectbox',
  SPIN: '/spin',
  SWIPER_SLIDER: '/swiperslider',
  TAB: '/tab',
  TABLE: '/table_ant',
  TRANSFER: '/transfer',
  TREE: '/tree',
  UPPY: '/uppy',
};
